import React, {Fragment, useContext, useState} from 'react';
import {
  Button,
  Grid,
  IconButton,
  List, ListItem, ListItemSecondaryAction, ListItemText,
  Typography
} from '@material-ui/core';
import {makeStyles, Theme} from '@material-ui/core/styles';
import {Edit} from '@material-ui/icons';

import {AuthContext} from '../../contexts';
import {PicklistItem as ListItemModel} from '../../models';

import {MaltEdit, MaltView} from '../Malt';
import useListFromFirestoreService
  from '../../helpers/useListFromFirestoreService';


const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    marginTop: theme.spacing(3)
  },
}));



const MaltsList = () => {
  console.log("Refreshing MaltsList");

  const classes = useStyles();

  const [_maltId, setMaltId] = useState<string|null>(null);
  const [_editing, setEditing] = useState<boolean>(false);
  const [_selectedIndex, setSelectedIndex] = useState<number|null>(null);

  const {itemLists} = useListFromFirestoreService(
      'beerLists', ['malts'], false);

  const {currentUserRoles} = useContext(AuthContext);
  const canContribute = currentUserRoles?.canContribute;

  const handleAdd = () => {
    setMaltId(null);
    setSelectedIndex(null);
    setEditing(true);
  };

  const handleDoneEditing = () => {
    setEditing(false);
    setSelectedIndex(null);
  };

  const handleEdit = (malt: ListItemModel) => {
    if (malt.id != null) {
      setMaltId(malt.id);
      setEditing(true);
    }
  };

  const handleSelect = (malt: ListItemModel, index: number) => {
    setSelectedIndex(index);
    setEditing(false);
    malt.id && setMaltId(malt.id);
  };

  return (
    <Grid container>
      <Grid item xs={6}>
        <Typography className={classes.title} variant="h2">
          Malts
        </Typography>
        {canContribute &&
          <Button
            size="small"
            color="primary"
            onClick={handleAdd}
          >
            Add
          </Button>
        }
        <List className={classes.root} dense>
          {itemLists.malts && itemLists.malts.map((malt, i) => (
          <Fragment key={i}>
            <ListItem
              divider
              selected={_selectedIndex === i}
              onClick={() => handleSelect(malt, i)}
            >
              <ListItemText
                primary={malt.name}
              />
              {canContribute &&
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    aria-label="edit"
                    onClick={() => handleEdit(malt)}
                  >
                    <Edit/>
                  </IconButton>
                </ListItemSecondaryAction>
              }
            </ListItem>
          </Fragment>
          ))}
        </List>
      </Grid>
      <Grid item xs={6}>
        {_editing
            ? <MaltEdit id={_maltId} onComplete={handleDoneEditing}/>
            : <MaltView id={_maltId}/>
        }
      </Grid>
    </Grid>
  );
};

export default MaltsList;
